import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { JabatanFormPayload } from "./validation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useFormMutation } from "@/hooks/useFormMutation";
import { useQuery } from "@tanstack/react-query";
import { DetailAnggotaResponse, JabatanResponse } from "./interface";

// GOLONGAN DAN ODP
// get
const getRank = async (
  query?: string
): Promise<ApiResponse<DataPaginate<KomisiResponse>>> => {
  return await fetcher(query ? `master/rank?${query}` : `master/komisi`);
};

export const useGetRank = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<KomisiResponse>>, Error>(
    ["useGetRank", query],
    () => getRank(query),
    {
      keepPreviousData: true,
      refetchIntervalInBackground: true,
    }
  );
};
//
// get
const getWorkUnit = async (
  query?: string
): Promise<ApiResponse<DataPaginate<KomisiResponse>>> => {
  return await fetcher(query ? `master/workUnit?${query}` : `master/komisi`);
};

export const useGetWorkUnit = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<KomisiResponse>>, Error>(
    ["useGetWorkUnit", query],
    () => getWorkUnit(query),
    {
      keepPreviousData: true,
      refetchIntervalInBackground: true,
    }
  );
};
// GOLONGAN DAN ODP

// get
const getJabatan = async (
  query?: string
): Promise<ApiResponse<JabatanResponse[]>> => {
  return await fetcher(
    query ? `infrastruktur/get?${query}` : `infrastruktur/get`
  );
};

export const useGetJabatan = (query?: string) => {
  return useQuery<ApiResponse<JabatanResponse[]>, Error>(
    ["useGetJabatan", query],
    () => getJabatan(query),
    {
      keepPreviousData: true,
      refetchIntervalInBackground: true,
    }
  );
};

// get by id
export const getJabatanId = async (
  id: number
): Promise<ApiResponse<DataObject<DetailAnggotaResponse>>> => {
  return await fetcher(`user/${id}`);
};

export const useGetJabatanId = (id: number) => {
  return useQuery<ApiResponse<DataObject<DetailAnggotaResponse>>, Error>(
    ["useGetJabatanId", id],
    () => getJabatanId(id)
  );
};

// post
export const useJabatan = (method: "POST" | "PUT" = "POST", id?: number) => {
  return useFormMutation<
    ApiResponse<DataObject<JabatanFormPayload>>,
    Error,
    JabatanFormPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<JabatanFormPayload>>> => {
      const endpoint = id ? `user/${id}` : "user";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<JabatanFormPayload>> =
        await sendData(endpoint, data, method);
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};
